export const environment = {
    production: false,
    baseUrl: 'https://ordserp19.open.com.ar/erp19/ppcdr/'
  };
